export const EMAIL_OR_PHONE = {
  required: 'Email or Phone is required',
  maxLength: { value: 100, message: 'Maximum of 100 characters' }
}

export const PIN = {
  required: 'PIN is required',
  maxLength: { value: 6, message: 'PIN must be 6 digits' },
  minLength: { value: 6, message: 'PIN must be 6 digits' }
}

export const removeHover = {
  _hover: { border: 'none', outline: 'none' },
  _active: { border: 'none', outline: 'none' },
  _focus: { border: 'none', outline: 'none' }
}

export const PLATE_NUMBER = {
  required: 'Vehicle Plate Number is required',
  maxLength: {
    value: 15,
    message: 'Vehicle Plate Number must be lesser than 15 characters '
  },
  pattern: {
    value: new RegExp('^[a-zA-Z0-9]*$'),
    message: 'Please Enter a valid Vehicle Plate Number'
  }
}

export const MAKE = {
  required: 'Vehice Brand is required'
}

export const MODEL = {
  required: 'Vehice Model is required'
}

export const CHASSIS_NUMBER = {
  required: 'Chassis is required',
  maxLength: { value: 17, message: 'Chassis Number must be 17 digits' },
  minLength: { value: 17, message: 'Chassis Number must must be 17 digits' },
  pattern: { value: new RegExp('^[a-zA-Z0-9]*$'), message: 'Please Enter a valid Chassis Number' }
}

export const BVN_NUMBER = {
  required: 'BVN is required',
  maxLength: { value: 11, message: 'BVN must be 11 digits' },
  minLength: { value: 11, message: 'BVN must be 11 digits' }
}

export const LAST_FOUR_DIGITS = {
  required: 'Last 4 digits of Mobile Number is required',
  maxLength: { value: 4, message: 'Last 4 digits must be 4 digits' },
  minLength: { value: 4, message: 'Last 4 digits must be 4 digits' }
}

export const PHONE = {
  required: 'Telephone is required',
  minLength: { value: 11, message: 'Telephone must be a minimum of 11 digits' },
  maxLength: { value: 11, message: 'Telephone must be a maximum of 11 digits' },
  pattern: { value: new RegExp('^[0-9]*$'), message: 'Please Enter a valid Telephone Number' }
}
